import { useEffect, useRef } from 'react';
import { useWebSocket } from '../context/WebSocketContext';

/** Re-run `refetch` whenever a live queue_update for `queueType` arrives. */
export const useLiveQueue = (queueType, refetch) => {
  const { lastQueueEvent } = useWebSocket();
  const seen = useRef(null);
  useEffect(() => {
    if (!lastQueueEvent || lastQueueEvent.queue_type !== queueType) return;
    if (seen.current === lastQueueEvent.seq) return;
    seen.current = lastQueueEvent.seq;
    refetch();
  }, [lastQueueEvent, queueType, refetch]);
};
